import axios from "axios";
import { resolveImageUrl, isDriveFolderLink } from "@/lib/driveUtils";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Canonical public domain used for any URL the app *generates and distributes*
// (WhatsApp/Instagram share links, OG tags) - regardless of which domain
// (custom domain or *.emergent.host) the visitor is actually browsing on.
export const CANONICAL_URL = process.env.REACT_APP_CANONICAL_URL;

// Points to the backend's /api/share/case/{slug} route (a real server, so it
// can serve per-case Open Graph tags for link-preview crawlers) on the
// canonical domain, before redirecting real visitors to the SPA page.
export function buildShareUrl(slug) {
  return `${CANONICAL_URL}/api/share/case/${slug}`;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function photoUrl(photo) {
  if (!photo) return null;
  if (photo.external_url) return resolveImageUrl(photo.external_url);
  if (photo.storage_path) return `${API}/files/${photo.storage_path}`;
  return null;
}

// Combines native uploaded photos + external_photo_link into a single list of
// directly-renderable image URLs (Google Drive file links are auto-converted).
export function getCasePhotoUrls(caseItem) {
  const urls = (caseItem.photos || []).map(photoUrl).filter(Boolean);
  if (caseItem.external_photo_link && !isDriveFolderLink(caseItem.external_photo_link)) {
    const resolved = resolveImageUrl(caseItem.external_photo_link);
    if (resolved) urls.push(resolved);
  }
  return urls;
}

export default api;

